import React, { Fragment } from 'react';
import { formatToTz } from 'utils/date-format';
import { PAYMENTS } from 'state/payment/type';
import BackButton from 'components/backButton';
import AmountDetails from 'components/amount-details';
import CopyIDToClipboard from 'components/copyToClipboard';
import useOrganisation from 'state/organisation/hooks/useOrganisation';
import { gatewatTransactionStatusFormatter } from '../../../../utils/status-formatter';
import STRING from 'utils/string';
import CURRENCY from 'utils/currency';

interface IProps {
  info: PAYMENTS.IGatewayTransaction;
}

const SummaryColumn = ({
  label,
  value,
}: {
  label: string;
  value: React.ReactNode;
}) => (
  <div className="flex flex-col items-start justify-between border-r-2 border-gray-blue-5 px-6 first:pl-0">
    <div className="mb-1 text-sm font-normal leading-5 text-gray-blue-50">
      {label}
    </div>
    <div className="text-sm font-normal leading-5 text-gray-blue-70">
      {value}
    </div>
  </div>
);

const GatewaySummary = ({
  info = {} as PAYMENTS.IGatewayTransaction,
}: IProps): JSX.Element => {
  const { organisation } = useOrganisation();
  const { settings } = organisation;
  const treezTicketID = STRING.getTreezTicketIDFromReferenceNumber(
    info.reference_number
  );

  return (
    <Fragment>
      <BackButton />
      <AmountDetails
        amount={CURRENCY.getGrossAmount(
          info.gross_receipt_paid_calculated,
          info.gross_receipt_paid,
          info.original_amount
        )}
        unit="USD"
        statusBadge={gatewatTransactionStatusFormatter(
          info.adjusted_status ?? info.status
        )}
      />
      <div className="flex items-center">
        <span className="mr-auto">
          <CopyIDToClipboard id={info.gateway_id || 'NA'} />
        </span>
      </div>
      <hr className="my-0" />

      <div className="mb-9 mt-1 flex items-center pt-2">
        <SummaryColumn
          label="Date"
          value={
            info.create_date
              ? formatToTz(
                  info.create_date,
                  settings?.timezone,
                  'MMM dd, hh:mm a'
                )
              : 'NA'
          }
        />
        <SummaryColumn label="Ticket ID" value={treezTicketID} />
        <SummaryColumn label="Payment method" value={info.method} />
      </div>
    </Fragment>
  );
};

export default GatewaySummary;
